// import { auth } from "../lib/axios";
import { Auth } from "aws-amplify";

export default class TokenService {
  async getToken() {
    let session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  }
}
